import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  header = (
    <>
      <h3
        style={{
          marginTop: 0,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h3>
      {/* <div className="navbar">
        <Link to={'/'}>About</Link>
        <Link to={'/blog'}>Blog</Link>
      </div> */}
    </>
  )
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <header style={{marginBottom: 10}}>{header}</header>
      <main>{children}</main>
      <footer>
      </footer>
    </div>
  )
}

export default Layout
